import { M8PartnerCancelledClientsDTO } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getCancelledClients = async (): Promise<
  M8PartnerCancelledClientsDTO
> => {
  const fetchURL = getM8PartnerURL('getCancelledClients');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
